require.context("../../images", true);
import { multipleSelect } from "./multiple_select";
import Menu from "./menu";
import MobileMenu from "./mobile_menu";
import "./foundation/validators";
new Menu({
  rootElement: ".desktop-main-nav",
  navItem: ".main-nav__item"
}).initialize();
new MobileMenu({
  rootElement: ".main-bar",
  navItem: ".main-nav__item"
}).initialize();
